import { formatToCurrency } from "../../helpers/FormatHelper";
import { getResource } from "../../helpers/ResourcesHelper";
import { usePaymentTransactionContext } from "./PaymentTransactionContext";

const TransactionSummary = () => {

  const {
    totalPayment,
    totalSettlement,
    totalFees,
    disbursements
  } = usePaymentTransactionContext();


  return <>
    <div className="col-md-12 col-xs-12 row start-xs">
      <h3>{getResource('Label.Totals')}</h3>
    </div>
    <div className="col-md-1 col-xs-10 row start-xs"></div>
    <div className="col-md-11 col-xs-10 row start-xs">
      <div className="col-md-12 col-xs-12 row start-xs">
        <h3>
          {getResource('Js_Action_Payments')}: {formatToCurrency((totalPayment).toString(), undefined, 2/*buyScale*/)}
        </h3>
      </div>
      <div className="col-md-12 col-xs-12 row start-xs">
        <h3>
          {getResource('Table_TH_Settlement')}: {formatToCurrency((totalSettlement).toString(), undefined, 2/*sellScale*/)}
        </h3>
      </div>
      <div className="col-md-12 col-xs-12 row">
        <h3>
          {getResource('Label.Fees')}: {formatToCurrency((totalFees).toString(), undefined, 2/*sellScale*/)}
        </h3>
      </div>
      <div className="col-md-8 col-xs-12 row">
        <h3>{getResource('Label.NumberLines')}: {Array.isArray(disbursements) ? disbursements.length : 0}</h3>
      </div>
    </div>
  </>
}

export default TransactionSummary
